import { getCookieValue } from "./Cookie";

// Mirrors rdc-ads-media `src/utils/privacy.ts` so FAR gates third-party ad/data
// scripts (e.g. Permutive) on the same CCPA opt-out + Global Privacy Control signals.

const CCPA_OPT_OUT_COOKIE_REGEX = /(?:^|;\s*)ccpaoptout=true(?:\s*;|$)/;

export const isPrivacyOptOut = () => {
  if (typeof window === "undefined") return false;
  return getCookieValue("ccpaoptout") === "true" || navigator?.globalPrivacyControl === true;
};

// Server-side (SSR) equivalent of isPrivacyOptOut. Per the GPC spec, GPC-enabled
// browsers/extensions attach a `Sec-GPC: 1` HTTP header to every request (including the
// initial document request), and the CCPA opt-out cookie arrives on the Cookie header.
export const isPrivacyOptOutRequest = (headers) => {
  if (!headers) return false;
  const secGpc = headers["sec-gpc"] ?? headers["Sec-GPC"];
  const secGpcValue = Array.isArray(secGpc) ? secGpc[0] : secGpc;
  if (secGpcValue?.trim() === "1") return true;

  const cookie = headers["cookie"] ?? headers["Cookie"];
  const cookieValue = Array.isArray(cookie) ? cookie.join("; ") : cookie;
  return CCPA_OPT_OUT_COOKIE_REGEX.test(cookieValue || "");
};

// Resolves opt-out from whichever side of the Next lifecycle we are on: `getInitialProps`
// runs on the server for the initial document request and on the client for client-side
// navigations, so pass `ctx.req` when it exists.
export const isPrivacyOptOutFromCtx = (req) =>
  req ? isPrivacyOptOutRequest(req.headers) : isPrivacyOptOut();

// Inline-script version of `isPrivacyOptOut`, embedded into the dangerouslySetInnerHTML
// pixel scripts. SSR HTML can be cached/served to a different visitor, so the script also
// re-checks the opt-out signals in the browser before loading anything third-party.
export const privacyOptOutInlineCheck = `(${CCPA_OPT_OUT_COOKIE_REGEX.toString()}.test(document.cookie) || navigator.globalPrivacyControl === true)`;
